import { render, staticRenderFns } from "./final-table.vue?vue&type=template&id=236e4c49&scoped=true"
import script from "./final-table.vue?vue&type=script&lang=js"
export * from "./final-table.vue?vue&type=script&lang=js"
import style0 from "./final-table.vue?vue&type=style&index=0&id=236e4c49&scoped=true&lang=css"
import style1 from "./final-table.vue?vue&type=style&index=1&id=236e4c49&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e4c49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236e4c49')) {
      api.createRecord('236e4c49', component.options)
    } else {
      api.reload('236e4c49', component.options)
    }
    module.hot.accept("./final-table.vue?vue&type=template&id=236e4c49&scoped=true", function () {
      api.rerender('236e4c49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/final-table.vue"
export default component.exports